export default __webpack_public_path__ + "static/header-dei-8-graphic-64f960d4ce1649c06c1adbd3140630e3.svg";